
































































import { colors } from 'quasar';
import { Component, Vue } from 'vue-property-decorator';
import LoginService from '../services/LoginService';

@Component
export default class Login extends Vue {

    public errorMessage: string = '';
    public username: string = '';
    public password: string = '';
    public redirect: string = '';

    public async mounted() {
      console.log('Login: mounted()');
      if ('redirect' in this.$route.params) {
        this.redirect = this.$route.params.redirect;
      }
    }

    public onReset() {
        this.username = '';
        this.password = '';
        this.errorMessage = '';
    }

    public onSubmit() {
        console.log('Login: onSubmit()');
        LoginService.login(this.username, this.password).then(() => {
            // won't get here, resolve will be redirected to AuthHandler
        }).catch((error) => {
            console.error(error);
            this.errorMessage = error.description;
        });

        // Faked login...
        // if ( (this.username === 'admin' && this.password === 'admin')
        //     || (this.username === 'chris' && this.password === 'chris')
        //     || (this.username === 'liam' && this.password === 'liam')
        //     || (this.username === 'keith' && this.password === 'keith') ) {
        //   this.$store.dispatch('login', {username: this.username, token: 'some-token-value'});
        //   if (this.redirect.length > 0) {
        //     this.$router.push({name: this.redirect});
        //   } else {
        //     this.$router.push({name: 'home'});
        //   }
        // } else {
        //   this.onReset();
        // }
    }

}
